import { Translate } from '@/services/Translate'

export default {
  install(Vue) {
    Vue.t = Translate
    Vue.prototype.$t = Translate
  }
}
